import { captureQueryParams } from './params-to-cookies'
import { widgetRedirectOptionsFor } from '~/composables/identityWidgetLoginUrl'

export default defineNuxtRouteMiddleware((to) => {
  if ('/' === to.path || !to.path || to.path === '/login') {
    const { notFound, returnToPath } = captureQueryParams(to)
    if (notFound) {
      return navigateTo('/404')
    }
    const options = widgetRedirectOptionsFor('login', to.query)
    // vue-router decodes a raw '+' in the query to a space, and an email address cannot contain one.
    if (options.email) options.email = options.email.replace(/ /g, '+')
    return redirectToWidget(returnToPath, options)
  }
});
